<script setup lang="ts">
import { ref } from "vue";
import { Router, useRouter } from "vue-router";

import SidebarMenu from "@/components/navigation/SidebarMenu.vue";

const isMenuOpen = ref( false );

function closeMenu() {
    isMenuOpen.value = false;
}
function openMenu() {
    isMenuOpen.value = true;
}

const router: Router = useRouter();
router.beforeEach( () => {
    isMenuOpen.value = false;
} );
</script>

<template>

    <!-- DESKTOP SIDEBAR -->
    <aside class="hidden overflow-y-auto rounded-lg shadow-lg bg-base-100 mt-4 min-w-64 lg:flex lg:flex-none lg:flex-col">
        <SidebarMenu />
    </aside>

    <!-- MOBILE SIDEBAR -->
    <div class="bg-base-100 flex flex-col relative z-50 lg:hidden" role="dialog" aria-modal="true">

        <transition
            enter-active-class="transition-opacity ease-linear"
            enter-from-class="opacity-0"
            enter-to-class="opacity-100"
            leave-active-class="transition-opacity ease-linear"
            leave-from-class="opacity-100"
            leave-to-class="opacity-0">
            <div v-if="isMenuOpen" @click="closeMenu()" class="fixed inset-0 bg-zinc-900/80" aria-hidden="true"></div>
        </transition>
        <transition
            enter-active-class="transition-opacity ease-linear"
            enter-from-class="opacity-0"
            enter-to-class="opacity-100"
            leave-active-class="transition-opacity ease-linear"
            leave-from-class="opacity-100"
            leave-to-class="opacity-0">
            <div v-if="isMenuOpen" class="fixed inset-0 flex">
                <transition
                    enter-active-class="transition ease-in-out transform"
                    enter-from-class="-translate-x-full"
                    enter-to-class="translate-x-0"
                    leave-active-class="transition ease-in-out transform"
                    leave-from-class="translate-x-0"
                    leave-to-class="-translate-x-full">
                    <div v-if="isMenuOpen" class="relative flex w-full max-w-64 flex-1">
                        <div class="absolute left-full top-0 flex justify-center">
                            <button type="button" @click="closeMenu()" class="p-5">
                                <span class="sr-only">Close sidebar</span>
                                <i class="pi pi-times text-white"></i>
                            </button>
                        </div>
                        <aside class="bg-base-100 flex flex-col h-dvh  h-screen overflow-y-auto w-64">
                            <SidebarMenu />
                        </aside>
                    </div>
                </transition>
            </div>
        </transition>
    </div>

    <button v-if=" !isMenuOpen " class="p-2 lg:hidden z-50 absolute start-0 top-0" @click="openMenu()">
        <i class="pi pi-bars"></i>
    </button>

</template>

<style scoped>
aside {
    scrollbar-width: thin;
}
</style>